import { ListItemText, ListItem, ListItemButton, IconButton, Collapse, List } from '@mui/material';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDownIcon, ChevronUpIcon } from '../../../assets/icons';
import { MenuWithChildren } from '../../../types/menu';
import { AppIcon } from '../../app-icon/AppIcon';
import { mobileHeaderStyles } from './styles';

interface MobileHeaderMenuItemProps {
  menu: MenuWithChildren;
}

export const MobileHeaderMenuItem: React.FC<MobileHeaderMenuItemProps> = ({ menu }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleIsMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <>
      <ListItem
        sx={{ p: 0 }}
        secondaryAction={
          menu.children &&
          menu.children.length > 0 && (
            <IconButton
              edge="end"
              onClick={toggleIsMenuOpen}
              aria-label={isMenuOpen ? 'Hide sub-menus' : `Show more ${menu.display_name} menus`}
            >
              <AppIcon
                fontSize="small"
                Icon={isMenuOpen ? ChevronUpIcon : ChevronDownIcon}
                titleAccess={isMenuOpen ? 'Close Menu' : 'Open Menu'}
              />
            </IconButton>
          )
        }
      >
        <ListItemButton sx={mobileHeaderStyles.menuLink} component={NavLink} to={menu.link} end>
          <ListItemText primary={menu.display_name} />
        </ListItemButton>
      </ListItem>
      {menu.children && menu.children.length > 0 && (
        <Collapse in={isMenuOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 2 }}>
            {menu.children.map((childMenu) => (
              <MobileHeaderMenuItem key={childMenu.id} menu={childMenu} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};
